<template>
    <div class="honor-dialog">
        <el-dialog
            :visible.sync="isShow"
            custom-class="honor-tip-dialog"
            top="20vh"
            width="560px"
            :before-close="closeDialog">
            <img class="whale-logo" src="../images/personal_center/whale_logo.png" alt="">
            <img class="close-icon" src="../images/personal_center/close1.png" alt="" @click="closeDialog">
            <strong>小鲸分析</strong>
            <template v-if="isPass">
                <p class="tips">恭喜您申请成功！</p>
                <p class="tips">工作人员将在 1 个工作日内联系您，请您耐心等待。</p>
            </template>
            <template v-else-if="isAllowApply">
                <p class="tips">
                    <span>申请核心用户需要 </span>
                    <span class="consume">消耗</span>
                    <span> 您当前以下金币：</span>
                </p>
                <p class="tips">1400 鲸币 = 500 普通鲸币 + 700 分享鲸币 + 200 专业鲸币</p>
                <p class="tips">请确认是否继续？</p>
            </template>
            <template v-else>
                <p class="tips">
                    <span>您当前的鲸币 </span>
                    <span class="incompatible">不符合</span>
                    <span> 核心用户最低的鲸币要求：</span>
                </p>
                <p class="tips">1400 鲸币 = 500 普通鲸币 + 700 分享鲸币 + 200 专业鲸币</p>
                <p class="tips">请继续加油！</p>
            </template>
            
            <div class="dialog-footer">
                <span v-if="!isPass" class="opera-btn" @click="confirmClick">{{ isAllowApply ? '确认申请' : '获取鲸币' }}</span>
                <span class="opera-btn" @click="closeDialog">{{ isPass ? '知道了' : '取消' }}</span>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            isPass: false,
            isAllowApply: true
        }
    },
    methods: {
        closeDialog () {
            this.$emit('closeDialog')
            this.isPass = false
            this.isAllowApply = true
        },
        confirmClick () {
            if (this.isAllowApply) {
                try {
                    axios.post(myUrl + "profile/vip/").then(res => {
                        const { code } = res.data
                        if (code === '-3') {
                            this.$message({
                                message: '您已成为核心用户！',
                                type: 'success'
                            })
                        } else if (code === '00') {
                            this.isPass = true
                        } else if (code === '-2') {
                            setTimeout(() => {
                                this.isAllowApply = false
                            }, 500)
                        }
                    })
                } catch (error) {
                    console.warn(error)
                }
            } else {
                this.closeDialog()
                window.open('https://bk.tencent.com/s-mart/community/question/4022', '_blank')
            }
        }
    }
}
</script>

<style lang="scss">
    .honor-tip-dialog {
        .el-dialog__header, .el-dialog__footer {
            display: none;
        }
        .el-dialog__body {
            height: 314px;
            position: relative;
            padding: 46px 0;
            text-align: center;
            font-size: 16px;
            border-radius: 4px;
            background: #fff url('../images/personal_center/dialog_banner1.png') no-repeat;
            background-position: top;
            background-size: 100% auto;
            strong {
                display: inline-block;
                font-size: 32px;
                color: #7b3f23;
                line-height: 45px;
                margin-bottom: 24px;
            }
            .whale-logo {
                position: absolute;
                left: 24px;
                top: -44px;
                width: 121px;
                height: 149px;
            }
            .close-icon {
                position: absolute;
                top: 18px;
                right: 27px;
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
            .tips {
                text-align: left;
                line-height: 36px;
                color: #7b3f23;
                margin-left: 72px;
                .incompatible, .consume {
                    color: #ea3636;
                }
            }
            .dialog-footer {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                bottom: 32px;
                left: 0;
                width: 100%;
                .opera-btn {
                    width: 200px;
                    height: 40px;
                    line-height: 38px;
                    border: 1px solid #979797;
                    border-radius: 33px;
                    color: #63656e;
                    margin-left: 16px;
                    cursor: pointer;
                    &:first-child{
                        border-color: #3a84ff;
                        background: #3a84ff;
                        color: #fff;
                        margin-left: 0;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// honor_dialog.vue?bafc76ce